import { getAPIUrl } from "@/stores/ApolloClient/helpers/getAPIUrl.ts";
import { isWithinInterval } from "date-fns";

export const filterDates = (date: Date) => {
  if (date < new Date(new Date().setHours(0, 0, 0, 0))) return true;

  if (getAPIUrl().includes("simuni")) {
    return simuniExcludedRanges.some((range) => {
      if (
        isWithinInterval(date, {
          start: new Date(range.from),
          end: new Date(range.to),
        })
      ) {
        if (range?.excludedDays) {
          return range.excludedDays.includes(date.getDay());
        }
        return true;
      }
      return false;
    });
  }

  if (getAPIUrl().includes("olea")) {
    return oleaExcludedRanges.some((range) => {
      return isWithinInterval(date, {
        start: new Date(range.from),
        end: new Date(range.to),
      });
    });
  }

  return false;
};

export const filterDateDefault = (date: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

// Specific to Šimuni, should be removed after the implementation of some per organization config from the backend
const simuniExcludedRanges = [
  { from: "2024-12-31", to: "2025-03-15" },
  { from: "2025-06-21", to: "2025-09-06", excludedDays: [0, 1, 2, 4, 5] },
  { from: "2025-11-15", to: "2025-12-31" },
  { from: "2024-11-15", to: "2024-12-31" },
];

const oleaExcludedRanges = [
  { from: "2024-12-05", to: "2025-04-25" },
  { from: "2026-10-05", to: "2028-12-31" },
];
